import { useState } from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { Navigate, useNavigate } from "react-router-dom";
import Cart from "../Cart/Cart";
import AdminProducts from "../AdminProducts/AdminProducts";
import AdminOrders from "../AdminOrders/AdminOrders";
import AdminCategories from "../AdminCategories/AdminCategories";
import ViewOrderModal from "../AdminOrders/ViewOrderModal";

const AdminPage = ({
  products,

  deleteProduct,
  orders,
  updateOrder,
  deleteOrder,
  categories,
  deleteCategory,
  logout,
  cart,
  total,
  removeFromCart,
}) => {
  const [currentTab, setCurrentTab] = useState("products");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    category: "",
    image: "",
    description: "",
  });
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [viewingOrder, setViewingOrder] = useState(null);
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showEditCategoryModal, setShowEditCategoryModal] = useState(false);
  const [editingCategoryIndex, setEditingCategoryIndex] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [cartOpen, setCartOpen] = useState(false);

  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormData({ ...formData, image: e.target.result });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddCategory = () => {
    setShowAddCategoryModal(false);
  };

  const handleEditCategory = (index) => {
    setShowEditCategoryModal(true);
  };

  const handleDeleteCategory = (index) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      deleteCategory(index);
    }
  };

  const handleEdit = (product) => {
    setEditingProduct(product);
    setFormData(product);
    setShowEditModal(true);
  };

  const handleUpdate = () => {
    setShowEditModal(false);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      deleteProduct(id);
    }
  };

  return userId ? (
    <div className="min-h-screen bg-gray-50">
      <Header
        cartCount={0}
        onCartClick={() => setCartOpen(true)}
        searchTerm=""
        setSearchTerm={() => {}}
        currentPage="admin"
        setCurrentPage={""}
        logout={logout}
      />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
          <h1 className="text-3xl font-black text-gray-900 mb-4 sm:mb-0">
            Admin Portal
          </h1>
          <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setCurrentTab("products")}
                className={`px-4 py-2 rounded-lg ${currentTab === "products" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
              >
                Products
              </button>
              <button
                onClick={() => setCurrentTab("orders")}
                className={`px-4 py-2 rounded-lg ${currentTab === "orders" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
              >
                Orders
              </button>
              <button
                onClick={() => setCurrentTab("categories")}
                className={`px-4 py-2 rounded-lg ${currentTab === "categories" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
              >
                Categories
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              {currentTab === "products" && (
                <button
                  onClick={() => setShowAddModal(true)}
                  className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                >
                  Add Product
                </button>
              )}
              {currentTab === "categories" && (
                <button
                  onClick={() => setShowAddCategoryModal(true)}
                  className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                >
                  Add Category
                </button>
              )}
              <button
                onClick={logout}
                className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
        {currentTab === "products" && (
          <AdminProducts
            products={products}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleUpdate={handleUpdate}
            showAddModal={showAddModal}
            setShowAddModal={setShowAddModal}
            showEditModal={showEditModal}
            setShowEditModal={setShowEditModal}
          />
        )}

        {currentTab === "categories" && (
          <AdminCategories
            categories={categories}
            handleEditCategory={handleEditCategory}
            handleDeleteCategory={handleDeleteCategory}
            showEditCategoryModal={showEditCategoryModal}
            setShowEditCategoryModal={setShowEditCategoryModal}
            showAddCategoryModal={showAddCategoryModal}
            setShowAddCategoryModal={setShowAddCategoryModal}
          />
        )}

        {currentTab === "orders" && (
          <AdminOrders
            orders={orders}
            updateOrder={updateOrder}
            setViewingOrder={setViewingOrder}
            setShowOrderModal={setShowOrderModal}
            deleteOrder={deleteOrder}
          />
        )}

        {/* Order View Modal */}
        {showOrderModal && (
          <ViewOrderModal
            viewingOrder={viewingOrder}
            setShowOrderModal={setShowOrderModal}
          />
        )}
      </main>
      <Footer />
      {cartOpen && (
        <Cart
          cart={cart}
          total={total}
          onRemove={removeFromCart}
          onClose={() => setCartOpen(false)}
          onCheckout={() => {
            navigate("/checkout");
            setCartOpen(false);
          }}
        />
      )}
    </div>
  ) : (
    <Navigate to="/admin-login" />
  );
};
export default AdminPage;
